import { useSeacrhEffect } from "./marketing-flow/use-search-effect";
import { useLoginEffect } from "./marketing-flow/use-login-effect";
import { useTrySignUpStepEffct } from "./marketing-flow/use-trySignUpStep-effect";
import { useClickGnbEffect } from "./marketing-flow/use-clickGnb-effect";
import { useClickFnbEffect } from "./marketing-flow/use-clickFnb-effect";
import { useClickSnsEffect } from "./marketing-flow/use-clickSns-effect";
import { useViewItemEffect } from "./marketing-flow/use-viewItem-effect";
import { useAddToCartEffect } from "./marketing-flow/use-addToCart-effect";
import { useAddToWishListEffect } from "./marketing-flow/use-addToWishList-effect";
import { useClickNoticeEffect } from "./marketing-flow/use-clickNotice-effect";
import { useDeActiveAccountEffect } from "./marketing-flow/use-deActiveAccount-effect";
import { useSubmitContactFormEffect } from "./marketing-flow/use-submitContactForm-effect";
import { useClickBannerEffect } from "./marketing-flow/use-clickBanner-effect";
import { useClickDesignEffect } from "./marketing-flow/use-clickDesign-efffect";
import { useClickTop5DesignerEffect } from "./marketing-flow/use-clickTop5Designer-effect";
import { useClickCategoryShopEffect } from "./marketing-flow/use-clickCategoryShop-effect";
import { useClickDetailPreviewEffect } from "./marketing-flow/use-clickDetailPreview-effect";
import { useClickDetailMoreByDesignerEffect } from "./marketing-flow/use-clickDetailMoreByDesigner-effect";
import { useClickDetailRelatedDesignsEffect } from "./marketing-flow/use-clickDetailRelatedDesigns-effect";
import { useClickDetailShareEffect } from "./marketing-flow/use-clickDetailShare-effect";
import { useClickFaqEffect } from "./marketing-flow/use-clickFaq-effect";
import { useClickTrendPost } from "./marketing-flow/use-clickTrendPost-effect";
import { useClickTrendAIPick } from "./marketing-flow/use-clickTrendAIPick-effect";
import { useClickFollowerDesigner } from "./marketing-flow/use-clickFollowerDesigner-effect";
import { useBeginCheckout } from "./marketing-flow/use-beginCheckout-effect";
import { useAiBeginCheckout } from "./marketing-flow/use-aibeginCheckout-effect";
import { usePurchaseEffect } from "./marketing-flow/use-purchase-effect";
import { useClickDetailZoomEffect } from "./marketing-flow/use-clickDetailZoom-effect";

export const marketingApi = {
  useSeacrhEffect,
  useLoginEffect,
  useTrySignUpStepEffct,
  useClickGnbEffect,
  useClickFnbEffect,
  useClickSnsEffect,
  useViewItemEffect,
  useAddToCartEffect,
  useAddToWishListEffect,
  useClickNoticeEffect,
  useDeActiveAccountEffect,
  useSubmitContactFormEffect,
  useClickBannerEffect,
  useClickDesignEffect,
  useClickTop5DesignerEffect,
  useClickCategoryShopEffect,
  useClickDetailPreviewEffect,
  useClickDetailRelatedDesignsEffect,
  useClickDetailMoreByDesignerEffect,
  useClickDetailShareEffect,
  useClickFaqEffect,
  useClickTrendPost,
  useClickTrendAIPick,
  useClickFollowerDesigner,
  useBeginCheckout,
  useAiBeginCheckout,
  usePurchaseEffect,
  useClickDetailZoomEffect
}